import React, { useState } from 'react';
import {
  View,
  Text,
  Pressable,
  ActivityIndicator,
  StyleSheet,
} from 'react-native';
import { Dashboard, operation } from '../services/operationsService';
import { useLanguage } from '../contexts/LanguageContext';
import CrossPlatformAlert from './CrossPlatformAlert';

export default function StoreBatchSettings({
  data,
  storeId,
  admin,
  onRefresh,
}: {
  data: Dashboard;
  storeId: string;
  admin: boolean;
  onRefresh: () => Promise<void>;
}) {
  const { t } = useLanguage();
  const tr = (key: string) => t(`operations.${key}`);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const store = data.stores.find((s) => s.id === storeId);
  const run = async (fn: () => Promise<unknown>) => {
    setBusy(true);
    try {
      await fn();
      await onRefresh();
    } catch (e) {
      CrossPlatformAlert.alert(tr('error'), String(e));
    } finally {
      setBusy(false);
    }
  };
  const initialize = () =>
    run(async () => {
      const check = await operation<{ issues?: string[] }>(
        'inventoryOperation',
        { action: 'previewMigration', storeId },
      );
      if (check.issues?.length) throw new Error(check.issues.join(', '));
      CrossPlatformAlert.alert(tr('initialize'), tr('confirmMigration'), [
        { text: tr('close'), style: 'cancel' },
        {
          text: tr('initialize'),
          onPress: () => {
            void run(() =>
              operation('inventoryOperation', {
                action: 'initialize',
                storeId,
              }, { timeout: 540000 }),
            );
          },
        },
      ]);
    });
  if (store?.inventoryVersion === 2 || !admin) return null;
  return (
    <View style={s.panel}>
      <Pressable
        style={s.button}
        accessibilityRole="button"
        accessibilityState={{ expanded: open }}
        onPress={() => setOpen(!open)}
      >
        <Text style={s.link}>
          {open ? '▾' : '▸'} {tr('initialize')}
        </Text>
      </Pressable>
      {open && (
        <View style={s.body}>
          {busy && <ActivityIndicator />}
          {store?.inventoryVersion !== 2 && (
            <>
              <Text>{tr('initializeFirst')}</Text>
              {admin && (
                <Pressable
                  disabled={busy}
                  style={s.button}
                  onPress={initialize}
                >
                  <Text style={s.link}>{tr('initialize')}</Text>
                </Pressable>
              )}
            </>
          )}

        </View>
      )}
    </View>
  );
}
const s = StyleSheet.create({
  panel: { backgroundColor: '#EFF6FF', margin: 12, borderRadius: 8 },
  button: { padding: 12 },
  body: { padding: 12, gap: 8 },
  link: { color: '#2563EB', fontWeight: '600' },
  label: { fontWeight: '700', color: '#334155' },
  row: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  flex: { flex: 1 },
});
